import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm';
import { Form, Validators } from '../../../components/form/DynamicFormTs';
import Http from '../../../Http';

export default class Correo extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'banco', saveUrl: 'banco/save', backUrl: '/Catalogo/Bancos' },
      new Form([
        Form.Field('checkbox', 'correo_autorizacion', 'Enviar correo de autorización cuando la recoleccion es fuera de horario', '', [], 12),
        Form.Field('checkbox', 'correo_otra_sucursal', 'Enviar correo de aviso cuando la preguia es desde otra sucursal', '', [], 12),
        Form.Field('text', 'correo_cco', 'Copiar todos los correos a', '', [], 12),
      ], ['Guardar'], 'Configurar Correos'), this.formData
    )
    this.LoadPreds();
  }

  LoadPreds = async () => {
    let Res = await Http.get(`prop/user`);
    if (!Res.error)
      this.setState({ FormData: Form.Patch(this.state.FormData, Res.data, true) })
  }

  onSubmit = async (i, vals) => {
    if (vals.correo_cco && !Validators.email(vals.correo_cco)) return;
    try {
      let Res = await Http.post('prop/user/save', { ...vals });
      if(!Res.error) {
        
      }
    } catch (error) {

    }
  }

  render() {
    return (
      <div style={{ minWidth: '100%', padding: '5px' }} >
        <this.FormRender {...this.props} />
      </div>
    )
  }
}
